<template lang="pug">
    div(class="relative bg-white w-full h-screen flex flex-col overflow-x-hidden")
        div(class="h-screen max-h-screen")
            div(class="flex items-center justify-between pl-10 pr-3 h-12 text-black uppercase font-bold bg-gray-lighter border-b border-gray-light") Sort

            div(class="overflow-y-auto h-[calc(100vh-56px)] pb-36")
                template(v-for="({ label }, index) in sorts")
                    div(@click="activeSort = index" class="flex cursor-pointer m-0 h-14 w-full pl-10 text-sm text-black border-b-2 border-gray-lighter items-center")
                        div(
                            class="sort m-0"
                            :class="index === activeSort ? 'is-active' : ''"
                        ) {{ label }}
</template>

<script>
import SearchComponent from '@/components/search/component'

export default {
    name: 'SortMenu',
    extends: SearchComponent,
    computed: {
        sorts() {
            return this.$searchContext.state.sorts
        },
        activeSort: {
            get() {
                return this.$searchContext.state.currentSort
            },
            set(index) {
                this.updateSort(index)
            },
        },
    },
    methods: {
        updateSort(index) {
            this.$searchContext.setSort(index)

            const { mod } = this.$route.query

            const routeObj = {
                name: this.$route.name,
                params: {
                    ...this.$route.params,
                    noUpdateScroll: true,
                },
                query: {
                    ...(mod && { mod }),
                    ...this.$searchContext.createRouteQuery(),
                },
            }

            this.$push.to(routeObj)
        },
    },
}
</script>

<style lang="stylus" scoped>
.sort
    &:before
        content ''
        width 20px
        height 20px
        border-radius 50%
        border 2px solid theme('colors.gray.light')
        display inline-block
        margin-right 15px
        position relative
        top 3px

        .is-active&
            border 7px solid theme('colors.action.DEFAULT')
</style>
